import { useCallback } from 'react';
import { Banner } from '@cbhq/cds-web/alpha/banner/Banner';
import { Button } from '@cbhq/cds-web/buttons/Button';
import { VStack } from '@cbhq/cds-web/layout';
import { TextLabel2 } from '@cbhq/cds-web/typography';

import useLocalStorage from ':cloud/hooks/useLocalStorage';
import { COINBASE_STATUS } from ':cloud/utils/links';
import { openUrlInNewWindow } from ':cloud/utils/openUrlInNewWindow';

function MaintenanceBanner() {
  const [showBanner, setShowBanner] = useLocalStorage('show-maintenance-banner', true);

  const handleDismiss = useCallback(() => {
    setShowBanner(false);
  }, [setShowBanner]);

  if (!showBanner) {
    return null;
  }

  return (
    <Banner
      showDismiss
      startIcon="info"
      styleVariant="global"
      title="Coinbase.com Scheduled Maintenance"
      variant="informational"
      onAbort={handleDismiss}
    >
      <VStack display="block">
        <TextLabel2 as="p" spacingBottom={2}>
          On Saturday, October 26, Coinbase will undergo a scheduled upgrade at 8:30 AM PT lasting
          up to 2 hours. Trading on Coinbase.com will be unavailable. We appreciate your patience.
        </TextLabel2>
        <Button onPress={() => openUrlInNewWindow(COINBASE_STATUS)}>Status Page</Button>
      </VStack>
    </Banner>
  );
}

export default MaintenanceBanner;
